// @flow

import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { ReactComponent as LogoIcon } from '@catalytic/catalytic-icons/lib/icons/logo.svg';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '2rem',
    height: '2rem',
    [theme.breakpoints.gte.mobile.portrait]: {
      width: '2.75rem',
      height: '2.75rem'
    }
  },
  icon: {
    fontSize: '2.25rem'
  }
}));

type Props = {
  to: string
};

const NavLogo = ({ to }: Props) => {
  const classes = useStyles();

  return (
    <Link className={classes.root} to={to}>
      <LogoIcon className={classes.icon} />
    </Link>
  );
};
NavLogo.displayName = 'NavLogo';
NavLogo.defaultProps = {
  to: '/'
};

export default NavLogo;
